import { type VariantProps, cva } from 'class-variance-authority'

export { default as Typography } from './Typography.vue'

export const typographyVariants = cva('text-white font-normal', {
  variants: {
    variant: {
      default: '',
      pageTitle: 'text-[32px] leading-[46px] font-semibold desktop:text-center',
      topbarItem: 'text-[13px] leading-[13px] font-medium',
      suggestionText: 'font-normal text-[13px] leading-[18px]',
      suggestionTitle: 'text-sm leading-[120%] font-semibold'
    },
    size: {
      default: '',
      'text-28': 'text-[28px]',
      'text-22': 'text-[22px]',
      'text-12-18': 'text-[12px] leading-[18px]',
      'text-13-18': 'text-[13px] leading-[18px]',
      'text-14-18': 'text-[14px] leading-[18px]',
      'text-14-16': 'text-[14px] leading-[16px]',
      'text-14-20': 'text-[14px] leading-[20px]',
      'text-16-24': 'text-[16px] leading-[24px]',
      'text-18-24': 'text-[18px] leading-[24px]',
      'text-22-26': 'text-[22px] leading-[26px]'
    },
    color: {
      default: 'text-white',
      secondary: 'text-secondary',
      inactive: 'text-text-inactive',
      helper: 'text-text-helper',
      success: 'text-best',
      error: 'text-blunder'
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
    color: 'default'
  }
})

export type TypographyVariants = VariantProps<typeof typographyVariants>
